import { trackEvent } from './posthog'

// Common event tracking functions
export const Analytics = {
  // User actions
  trackSignIn: (method: 'email' | 'google') => {
    trackEvent('user_signed_in', { method })
  },

  trackSignUp: (method: 'email' | 'google') => {
    trackEvent('user_signed_up', { method })
  },

  trackSignOut: () => {
    trackEvent('user_signed_out')
  },

  // Navigation
  trackPageView: (page: string) => {
    trackEvent('page_viewed', { page })
  },

  // Memory operations
  trackMemoryCreated: (environment: string) => {
    trackEvent('memory_created', { environment })
  },

  trackMemoryDeleted: (environment: string) => {
    trackEvent('memory_deleted', { environment })
  },

  trackMemoryExported: (format: string, count: number) => {
    trackEvent('memory_exported', { format, count })
  },

  // API Key operations
  trackApiKeyCreated: (environment: string) => {
    trackEvent('api_key_created', { environment })
  },

  trackApiKeyDeleted: (environment: string) => {
    trackEvent('api_key_deleted', { environment })
  },

  // Team operations
  trackTeamMemberInvited: (role: string) => {
    trackEvent('team_member_invited', { role })
  },

  trackTeamMemberRemoved: () => {
    trackEvent('team_member_removed')
  },

  // Billing
  trackSubscriptionStarted: (plan: string) => {
    trackEvent('subscription_started', { plan })
  },

  trackSubscriptionCancelled: () => {
    trackEvent('subscription_cancelled')
  },

  // Feature usage
  trackFeatureUsed: (feature: string) => {
    trackEvent('feature_used', { feature })
  },

  // Error tracking
  trackError: (error: string, context?: Record<string, unknown>) => {
    trackEvent('error_occurred', { error, ...context })
  },

  // Search and filtering
  trackSearch: (query: string, filters: Record<string, unknown>) => {
    trackEvent('search_performed', { query, filters })
  },

  trackFilterApplied: (filterType: string, value: string) => {
    trackEvent('filter_applied', { filterType, value })
  },

  // Settings
  trackSettingChanged: (setting: string, value: unknown) => {
    trackEvent('setting_changed', { setting, value })
  },

  // Help and support
  trackHelpViewed: (topic: string) => {
    trackEvent('help_viewed', { topic })
  },

  trackSupportContacted: (method: string) => {
    trackEvent('support_contacted', { method })
  }
} 